<template>
  <div
    :id="`vendor-assessment-review-question-attachment-${checklistItemDataRaw.checklistItemId}`"
    :class="`tw-flex tw-flex-col assessmentQuestion tw-text-[#231F20] tw-text-base tw-font-[Poppins] tw-rounded-t-[6px]`"
    @mouseover="onHoverIn"
    @mouseout="onHoverOut"
  >
    <div
      :class="`tw-flex tw-p-[15px] md:tw-p-[25px] question ${
        isSelected ? 'tw-bg-[rgba(242,248,255,0.5)]' : ''
      }`"
    >
      <div class="tw-w-full mainWrapper">
        <div class="tw-grid tw-grid-cols-5 gap-3">
          <div
            ref="assessmentQuestionContainerRef"
            class="tw-col-span-5 md:tw-col-span-3 xl:tw-col-span-4"
          >
            <div class="tw-flex tw-w-full tw-relative">
              <div
                :id="`vendor-assessment-review-question-attachment-radio-${checklistItemDataRaw.checklistItemId}`"
                :class="`tw-flex tw-items-center tw-justify-start tw-mr-[15px] tw-h-[fit-content] tw-mt-[2px]`"
              >
                <ToggleIcon
                  :class="`${
                    isExclude || checklistItemDataRaw.checklistItemIsNa
                      ? `tw-opacity-50`
                      : 'tw-cursor-pointer'
                  }`"
                  :ticked="isSelected"
                  color="#387dff"
                  @click="handleSelectedQuestions(checklistItemDataRaw)"
                />
              </div>
              <div
                :class="`tw-flex tw-flex-col tw-gap-[20px] tw-w-full questionWrapper`"
              >
                <div
                  v-if="
                    checklistItemDataRaw?.visibleState ===
                    assessmentQuestionVisibleState.prefilled
                  "
                  :id="`vendor-assessment-review-question-attachment-tag-${checklistItemDataRaw.checklistItemId}`"
                  class="prefilled"
                >
                  <AssessmentQuestionPrefilledTag
                    :number-question="''"
                    :text="prefilledTitle"
                    color="green"
                    :expand="!isCollapsed"
                  />
                </div>
                <div class="tw-flex tw-justify-between tw-items-center">
                  <div class="tw-flex tw-gap-[15px]">
                    <div
                      class="tw-flex tw-items-center tw-gap-[10px] tw-text-[#231F20] tw-text-[16px] tw-not-italic tw-font-normal tw-leading-[normal]"
                    >
                      <p
                        :class="`text-with-icon ${
                          isExclude || checklistItemDataRaw.checklistItemIsNa
                            ? `greyed`
                            : ''
                        }`"
                      >
                        <slot name="default">
                          <span
                            class="tw-text-[#231F20] tw-text-base tw-font-[Poppins]"
                            data-cy="question-name"
                            :data-id="`${checklistItemDataRaw.checklistItemId}`"
                          >
                            {{
                              checklistItemDataRaw.checklistItemHeadingLabel ||
                              checklistItemDataRaw.checklistItemName
                            }}
                            {{
                              checklistItemDataRaw.subName
                                ? ` | ${checklistItemDataRaw.subName}`
                                : ""
                            }}
                          </span>
                        </slot>
                        <span
                          v-if="
                            (checklistItemDataRaw.checklistItemDescription ||
                              checklistItemDataRaw.checklistItemGuidance) &&
                            onHover
                          "
                          class="info-icon tw-ml-[15px] md:tw-ml-[25px]"
                        >
                          <ButtonShowDuplicateAssessment
                            :id-popover="'popover' + Math.random() * 1000"
                            :custom-class="'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
                            :class="`!tw-p-0 tw-leading-[16px]`"
                            :classes="`!tw-leading-none tw-flex tw-items-center tw-justify-center`"
                          >
                            <div class="tw-p-[15px] tw-w-[475px]">
                              <div
                                class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
                              >
                                <div
                                  v-if="
                                    checklistItemDataRaw.checklistItemDescription
                                  "
                                >
                                  <div
                                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                                  >
                                    {{
                                      getComponentUiText(
                                        "app-menu-submenu-assessments-further-information-1",
                                      )
                                    }}
                                  </div>
                                  <CustomDescriptionContent
                                    :description="
                                      checklistItemDataRaw.checklistItemDescription
                                    "
                                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                                  >
                                  </CustomDescriptionContent>
                                </div>
                                <div
                                  v-if="
                                    checklistItemDataRaw.checklistItemGuidance
                                  "
                                >
                                  <div
                                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                                  >
                                    {{
                                      getComponentUiText(
                                        "app-menu-submenu-assessments-guidance-1",
                                      )
                                    }}
                                  </div>
                                  <CustomDescriptionContent
                                    :description="
                                      checklistItemDataRaw.checklistItemGuidance
                                    "
                                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                                  >
                                  </CustomDescriptionContent>
                                </div>
                              </div>
                            </div>
                          </ButtonShowDuplicateAssessment>
                        </span>
                      </p>
                      <div
                        v-if="checklistItemDataRaw.checklistItemIsNa"
                        class="prefilled"
                      >
                        <AssessmentQuestionNotApplicableTag
                          color="grey"
                          :expand="!isCollapsed"
                        />
                      </div>
                      <StatusBadge
                        v-if="evaluateAnswer"
                        class="tw-w-fit"
                        :data-cy="`status-badge-lable-${checklistItemDataRaw.checklistItemId}`"
                        :lable-class="`tw-max-w-fit`"
                        :label="getLabelEvaluateTag() ?? ''"
                        :value="getValueEvaluateTag() ?? ''"
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    isExpanded &&
                    !isExclude &&
                    dataTableFileFormatted?.length === 0 &&
                    !checklistItemDataRaw.checklistItemIsNa
                  "
                  :class="`tw-mt-[5px] tw-max-w-[965px] ${
                    isExclude || checklistItemDataRaw.checklistItemIsNa
                      ? `tw-opacity-50`
                      : ''
                  }`"
                >
                  <p
                    class="tw-text-[#231F20] tw-text-[15px] tw-font-medium tw-mb-[15px]"
                  >
                    <span>{{
                      getComponentUiText(
                        "app-component-assessments-assessment-question-add-attachments-1",
                      )
                    }}</span>
                  </p>

                  <FileUploader
                    v-if="file"
                    ref="fileUploaderRef"
                    v-model:file="file"
                    :id-input="`vendor-assessment-input-file-${checklistItemDataRaw.checklistItemId}`"
                    class="xl:tw-max-w-[calc(100%-130px)] 2xl:tw-max-w-[calc(100%-50px)]"
                    :crop="false"
                    :guidance="
                      getComponentUiText(
                        'app-component-assessments-evidence-modal-upload-file-guidance-1',
                        false,
                        { maxSize: MAX_EVID_SIZE },
                      )
                    "
                    :crop-modal-title="
                      getComponentUiText(
                        'app-settings-organisation-profile-avatar-cropper-heading-1',
                      )
                    "
                    :crop-formats="
                      getComponentUiText(
                        'app-settings-organisation-profile-avatar-cropper-formats-1',
                        false,
                        { maxSize: MAX_EVID_SIZE },
                      )
                    "
                    :font-size-title="12"
                    :is-evidence="true"
                    @update:file="uploadFile"
                    @on-image-remove="refreshImage"
                  />
                  <div
                    v-else
                    class="tw-text-[#878787] tw-text-[12px] tw-flex tw-items-center tw-justify-center xl:tw-max-w-[calc(100%-130px)] 2xl:tw-max-w-[calc(100%-50px)] tw-h-[140px] tw-bg-[#eff0f180] tw-border tw-border-solid tw-rounded-md tw-border-[#eff0f1] tw-p-[25px] tw-text-center"
                  >
                    {{
                      getComponentUiText(
                        "app-component-assessments-evidence-modal-upload-file-no-attachments-1",
                      )
                    }}
                  </div>
                </div>
                <!-- File Uploaded Table -->
                <div
                  v-if="
                    isExpanded &&
                    !isExclude &&
                    dataTableFileFormatted?.length > 0 &&
                    !checklistItemDataRaw.checklistItemIsNa
                  "
                  class="tw-mt-[5px] tw-flex tw-gap-[20px] additionalInfo tw-flex-col tw-items-start"
                >
                  <div class="tw-flex tw-items-center tw-justify-between">
                    <span
                      class="tw-text-[#231F20] tw-text-[15px] tw-font-medium tw-mb-[15px]"
                      >{{
                        getComponentUiText(
                          "app-assessments-vendor-questions-upload-table-title-1",
                        )
                      }}</span
                    >
                  </div>
                  <CustomTable
                    :id="`vendor-assessment-review-question-attachment-file-table-${checklistItemDataRaw.checklistItemId}`"
                    :columns="tableFileFields"
                    :data="dataTableFileFormatted"
                    :empty-text="
                      getComponentUiText(
                        'app-assessments-vendor-questions-upload-table-empty-1',
                      )
                    "
                    :custom-class="`xl:tw-max-w-[calc(100%-130px)] 2xl:tw-max-w-[calc(100%-50px)]`"
                    @update-selected-rows="updateSelectedRows"
                    @current-image="getAttachment"
                  >
                    <template #cell(name)="data">
                      <a
                        class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal] tw-cursor-pointer"
                        @click="
                          downloadAttachment(data.item?.attachmentId, true)
                        "
                        >{{ data.value }}</a
                      >
                    </template>
                    <template #cell(uploadedBy)="data">
                      <CellTableInfo :value="data.value" />
                    </template>

                    <template #cell(action)="data">
                      <CellTableAction
                        :id="
                          'assessment-question-sub-category-' +
                          data.item.attachmentId +
                          data.idx
                        "
                        :value="data"
                        :is-internal="true"
                        :actions="tableFileActions"
                        @manage-user="
                          (value, action) => {
                            if (action === actionClickType.actionDownload) {
                              downloadAttachment(
                                value.attachmentId || value.id,
                              );
                            } else if (
                              action === actionClickType.actionRemoveFile
                            ) {
                              deleteAttachment(
                                data.item.attachmentId || data.item.id,
                              );
                            }
                          }
                        "
                      />
                    </template>
                  </CustomTable>
                </div>
              </div>
            </div>
          </div>

          <div class="tw-col-span-5 md:tw-col-span-2 xl:tw-col-span-1">
            <div
              class="tw-flex tw-flex-col tw-gap-[20px] tw-items-end tw-justify-center tw-h-full"
            >
              <span
                v-if="
                  checklistItemDataRaw?.visibleState ===
                    assessmentQuestionVisibleState.prefilled &&
                  !checklistItemDataRaw.checklistItemIsNa
                "
                class="tw-cursor-pointer tw-absolute md:tw-relative md:tw-top-[unset] tw-top-[22px] tw-right-[18px] arrow"
                @click="isCollapsed = !isCollapsed"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  :style="isCollapsed ? 'transform: rotate(180deg)' : ''"
                >
                  <path
                    d="M11.8741 6.38894L6.38429 0.165448C6.33485 0.113191 6.27527 0.0715663 6.2092 0.0431191C6.14312 0.0146718 6.07194 -2.59124e-07 6 -2.62268e-07C5.92806 -2.65413e-07 5.85688 0.0146718 5.7908 0.0431191C5.72473 0.0715663 5.66515 0.113191 5.61571 0.165448L0.125859 6.38894C0.081969 6.43838 0.0483386 6.49604 0.02692 6.55858C0.00550146 6.62113 -0.00327902 6.6873 0.00108975 6.75327C0.0065009 6.81976 0.0251891 6.8845 0.056049 6.94364C0.086909 7.00279 0.129313 7.05515 0.180757 7.09763L1.10405 7.8712C1.15449 7.91483 1.21315 7.9479 1.27658 7.96848C1.34002 7.98905 1.40693 7.9967 1.47337 7.99098C1.53949 7.9862 1.604 7.96828 1.66313 7.93829C1.72225 7.9083 1.77481 7.86683 1.81773 7.8163L5.91516 3.10002C5.94039 3.07503 5.97447 3.06101 6.00998 3.06101C6.04549 3.06101 6.07957 3.07503 6.10481 3.10002L10.1823 7.8163C10.2629 7.91267 10.377 7.97505 10.5017 7.99098C10.5678 7.99738 10.6345 7.99052 10.6979 7.97081C10.7613 7.9511 10.8202 7.91893 10.871 7.87619L11.8192 7.09763C11.8707 7.05515 11.9131 7.00279 11.9439 6.94364C11.9748 6.8845 11.9935 6.81976 11.9989 6.75327C12.0033 6.6873 11.9945 6.62113 11.9731 6.55859C11.9517 6.49604 11.918 6.43838 11.8741 6.38894Z"
                    fill="#DBDBDB"
                  />
                </svg>
              </span>
              <div
                v-if="
                  !(
                    checklistItemDataRaw?.visibleState ===
                    assessmentQuestionVisibleState.prefilled
                  ) || !isCollapsed
                "
                :class="`tw-flex tw-items-center tw-w-[100%] tw-gap-[20px] md:tw-justify-end tw-justify-start`"
              >
                <span
                  v-if="!isExclude && onHover"
                  class="tw-flex tw-gap-[20px] tw-items-center"
                >
                  <ExpandingButton
                    :id="`vendor-assessment-review-question-attachment-notes-icon-${checklistItemDataRaw.checklistItemId}`"
                    color="#387DFF"
                    :icon="PenIcon"
                    :text="
                      getComponentUiText(
                        'app-component-assessments-override-question-note-title-1',
                      )
                    "
                    @click="showAdvanceModal"
                  />
                  <ExpandingButton
                    :id="`vendor-assessment-review-question-attachment-evidence-icon-${checklistItemDataRaw.checklistItemId}`"
                    :class="
                      isChecklistCompleted &&
                      checklistItemDataRaw.checklistItemAttachments?.length ===
                        0
                        ? '!tw-transform-none'
                        : ''
                    "
                    :color="
                      isChecklistCompleted &&
                      checklistItemDataRaw.checklistItemAttachments?.length ===
                        0
                        ? '#62a2f5'
                        : '#387DFF'
                    "
                    :icon="PinIcon"
                    :text="
                      getComponentUiText(
                        'app-component-assessments-evidence-button-title-1',
                      )
                    "
                    max-width="95px"
                    @click="showAdvanceModal"
                  />
                  <div>
                    <ButtonShowMore
                      :id-popover="`vendor-assessment-review-question-attachment-popover-${checklistItemDataRaw.checklistItemId}`"
                      :classes="`!tw-p-[0px]`"
                    >
                      <CustomDropDownItem
                        v-if="viewStyle !== TYPE_ASSESSMENT_VIEW_STYLE.vendor"
                        :style="`tw-self-center ${
                          isChecklistCompleted
                            ? '!tw-cursor-not-allowed normal'
                            : 'normal'
                        }`"
                        :id-text="'app-component-vendor-question-advance-option-1'"
                        :style-text="'!tw-self-auto'"
                        @click="showAdvanceModal"
                      />
                    </ButtonShowMore>
                  </div>
                </span>
                <!--
 <div
                  v-if="checklistItemDataRaw.isMaster"
                  :id="`vendor-assessment-review-question-attachment-add-item${checklistItemDataRaw.checklistItemId}`"
                  @click="addItemAction"
                >
                  <button
                    class="tw-flex tw-w-[102px] tw-justify-center tw-gap-[10px] tw-h-[fit-content] tw-pt-[8px] tw-pb-[8px] tw-pr-[20px] tw-pl-[20px] tw-rounded-[100px] tw-text-center tw-text-[#387DFF] !tw-no-underline tw-text-[13px] tw-font-[500] tw-font-[Poppins] add-item-button`"
                  >
                    {{
                      getComponentUiText(
                        "app-component-assessments-assessment-button-add-item-1",
                      )
                    }}
                  </button>
                </div> 
-->
                <div
                  v-if="
                    checklistItemDataRaw.itemCompleteValue !== undefined ||
                    isExclude
                  "
                  class="tw-flex tw-gap-[20px]"
                >
                  <CircularProgressPercent
                    v-if="checklistItemDataRaw.itemCompleteValue !== undefined"
                    :id="`vendor-assessment-review-question-attachment-circular-percent-${checklistItemDataRaw.checklistItemId}`"
                    :data-cy="`circular-percent-${checklistItemDataRaw.checklistItemId}`"
                    :percent="checklistItemDataRaw.itemCompleteValue"
                    :compensating-override-score="
                      checklistItemDataRaw.checklistItemCompensatingControlValue
                    "
                    :compliance-override-score="
                      checklistItemDataRaw.checklistItemComplianceOverride
                    "
                    :class="'tw-cursor-pointer'"
                    :excluded="isExclude"
                    :size="44"
                    :text-size="11"
                  />
                  <Button4
                    v-if="isExclude"
                    :id="`vendor-assessment-review-question-attachment-btn-exclude-${checklistItemDataRaw.checklistItemId}`"
                    :class="`tw-self-center ${
                      isChecklistCompleted ? '!tw-cursor-not-allowed' : ''
                    }`"
                    @click="handleExclude"
                  >
                    {{
                      getComponentUiText("app-component-assessments-include-1")
                    }}
                  </Button4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <CircularProgressPercent
          v-if="
            (selected === 0 || selected === 1) &&
            !checklistItemDataRaw.checklistItemIsNa
          "
          :percent="selected === 0 ? 0 : 100"
          :compensating-override-score="
            checklistItemDataRaw.checklistItemCompensatingControlValue
          "
          :compliance-override-score="
            checklistItemDataRaw.checklistItemComplianceOverride
          "
          :class="'tw-cursor-pointer'"
          :excluded="
            checklistItemDataRaw?.visibleState ===
            assessmentQuestionVisibleState.no
          "
        />
      </div>
    </div>
    <VendorAssessmentQuestionEvaluate
      :id="`vendor-assess-review-question-attachments-evaluate-${checklistItemDataRaw.checklistItemId}`"
      :id-question="`${checklistItemDataRaw.checklistItemId}`"
      class="tw-mx-0 tw-p-[20px]"
      :checklist-item-data-raw="checklistItemDataRaw"
      :is-checklist-completed="isChecklistCompleted"
      :id-dropdown="`vendor-assess-review-question-evaluate-dropdown-${checklistItemDataRaw.checklistItemId}`"
      :id-note-input="`vendor-assess-review-question-evaluate-note-input-${checklistItemDataRaw.checklistItemId}`"
      :id-percent-input="`vendor-assess-review-question-evaluate-percent-input-${checklistItemDataRaw.checklistItemId}`"
      :background-input="`white`"
      :is-show-label="false"
      @update:evaluate-answer="handleSelectedEvaluateAnswer"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  Ref,
  ref,
  watch,
  computed,
  onMounted,
  PropType,
  ComputedRef,
} from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import {
  API_STATUS_LOADING,
  CHECKLIST_TYPE,
  MODAL_NAME,
  TYPE_ASSESSMENT_VIEW_STYLE,
  TYPE_MODAL_SECURING_EVIDENCE,
  actionClickType,
  assessmentQuestionVisibleState,
  localStorageKey,
  statusCode,
  successStatusCodes,
} from "@/utils/constants";
import PinIcon from "../svgs/pinIcon.vue";
import PenIcon from "../svgs/penIcon.vue";
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import AssessmentQuestionPrefilledTag from "../assessment/assessmentQuestionPrefilledTag.vue";
import AssessmentQuestionNotApplicableTag from "../assessment/assessmentQuestionNotApplicableTag.vue";
import ExpandingButton from "../common/expandingButton.vue";
import utilities, {
  getComponentUiText,
  getPasswordDefaultVendorAttachment,
} from "@/utils/utilities";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import Button4 from "../common/button4.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { addItemFromMaster } from "@/services/assessment";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { onUnmounted } from "vue";
import { Handler } from "mitt";
import FileUploader from "../common/fileUploader.vue";
import StatusBadge from "../common/setting/statusBadge.vue";
import CustomTable from "../common/customTable.vue";
import CellTableInfo from "../common/setting/cellTableInfo.vue";
import CellTableAction from "../common/setting/cellTableAction.vue";
import VendorAssessmentQuestionEvaluate from "../vendor/vendorAssessmentQuestionEvaluate.vue";
import { showError, showErrorAPI } from "@/services/apiRoutes";
import { decryptFileBase64, decryptText } from "@/utils/cipher";
import { IModalMessage } from "@/interfaces/common/common";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { deleteVendorRequestAssessmentAttachment } from "@/services/vendor";
import { Vendor } from "@/services/apiRoutes/routes";
import AssessmentAnswerType1 from "../assessments/assessmentAnswerType1.vue";
import { fileSizeFormat } from "@/utils/dateTimeUtils";

const TABLE_DATA_FILE = [];

const props = defineProps({
  checklistId: { type: Number, default: 0 },
  level: { type: Number, default: 0 },
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  checklistItem: {
    type: Object,
    default: () => ({}),
  },
  prefilledTitle: { type: String, default: "" },
  isShowYesNoQuestion: { type: Boolean, default: true },
  isShowRequiredTag: { type: Boolean, default: true },
  viewStyle: {
    type: String as PropType<keyof typeof TYPE_ASSESSMENT_VIEW_STYLE>,
    default: TYPE_ASSESSMENT_VIEW_STYLE.user,
  },
  isSelectedAll: {
    type: Boolean,
    default: false,
  },
});

let setTimeOutRef: any = null;
const route = useRoute();
const onHover: Ref<boolean> = ref(false);
const isCollapsed: Ref<boolean> = ref(true);
const passkeyQuestion: Ref<string> = ref("");
const isSelected = ref(props.isSelectedAll);
const file: Ref = ref(null);
const fileUploaderRef: Ref = ref(null);
const assessmentQuestionContainerRef: Ref = ref(null);
const isExpanded: Ref<boolean> = ref(true);
const MAX_EVID_SIZE = fileSizeFormat(
  process.env.VUE_APP_MAX_EVID_SIZE || 52428800,
);

const checklistItemDataRaw = computed(() => {
  return props.checklistItem;
});
const providerId = computed(
  () =>
    store.state.Vendor.requestedDetailItem?.checklistsRequested[0].providerId,
);
const dataTableFileFormatted = computed(() => {
  const checklistVendorRequestedInput =
    store.state.Vendor.requestedDetailItem?.checklistsRequested[0];
  const additionalData =
    checklistVendorRequestedInput.checklistRequestedItems.find(
      (item) =>
        item.checklistItemId === checklistItemDataRaw.value.checklistItemId,
    )?.additionalData;
  return additionalData.length ? additionalData[0].attachments : [];
});

const isExclude: Ref<boolean> = computed(() => {
  return (
    checklistItemDataRaw.value?.visibleState ===
    assessmentQuestionVisibleState.no
  );
});

const evaluateOptions = computed(() => {
  const data = store.state.Assessment.assessmentQuestionTypes?.find(
    (item) =>
      item.id === checklistItemDataRaw.value?.checklistItemComplianceTypeOrgId,
  );

  if (!data) return [];

  return data.complianceTypeValues;
});

const selected = ref<number | undefined>(
  props.checklistItem.checklistItemComplianceTypeValueId,
);

const evaluateAnswer: Ref = ref(
  checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    ? checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    : null,
);

watch(
  () => props.isSelectedAll,
  (value) => {
    isSelected.value = value;
  },
);

const handleSelectedEvaluateAnswer = (value) => {
  if (value["complianceTypeValueOrgId"])
    evaluateAnswer.value = value["complianceTypeValueOrgId"];

  emits("update:answer", {
    ...value,
    checklistRequestedItemId: checklistItemDataRaw.value.checklistItemId,
  });
};

const getLabelEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  return selected?.label;
};

const getValueEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  if (!selected) return "";
  if (selected?.order === 1) return statusCode.notAccepted;
  if (selected?.order === 2) return statusCode.informationRequired;
  if (selected?.order === 3) return statusCode.accepted;
};

const isChecklistCompleted: ComputedRef<boolean> = computed(() => false);

// File Table.
const selectedFileTableRow: Ref<any[]> = ref([]);
const isShowMoreActionsFileTable = ref(false);

const tableFileFields = [
  {
    text: getComponentUiText("app-component-custom-table-header-document-1"),
    value: "name",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<a class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal] tw-cursor-pointer">${value}</a>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-size-1"),
    value: "size",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-date-1"),
    value: "date",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-uploaded-by-1"),
    value: "uploadedBy",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];
const tableFileActions = computed(() =>
  isChecklistCompleted.value
    ? [actionClickType.actionDownload]
    : [actionClickType.actionRemoveFile, actionClickType.actionDownload],
);

const emits = defineEmits([
  "update:answer",
  "openDowloadFileModal",
  "exclude",
  "update:selected",
  "showModalAddNoteAssessment",
  "uploadFile",
  "showAdvanceModal",
]);

const showAdvanceModal = () => {
  emits("showAdvanceModal", passkeyQuestion.value);
};

const refreshImage = () => {
  fileUploaderRef.value = null;
  file.value = null;
};

const loadingImg = ref(API_STATUS_LOADING.NO_ACTION);

const uploadFile = (file: any) => {
  emits("uploadFile", {
    file,
    checklistItemId: checklistItemDataRaw.value.checklistItemId,
  });
};

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;

  if (window.innerWidth < 768) return;
  // assessmentQuestionContainerRef.value.style.maxWidth = "calc(100% - 197px)";
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
    if (assessmentQuestionContainerRef.value) {
      assessmentQuestionContainerRef.value.style.maxWidth = "100%";
    }
  }, 150);
};

const handleExclude = () => {
  if (isChecklistCompleted.value) return;
  emits("exclude", checklistItemDataRaw.value.checklistItemId);
};

const initial = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (
      data.password &&
      data.checklistItemId === checklistItemDataRaw.value.checklistItemId
    ) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);
};

onUnmounted(() => {
  EventEmitter.off(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION);
});

// const addItemAction = async () => {
//   const res = await addItemFromMaster(Number(route.query.checklistId), [
//     checklistItemDataRaw.value.checklistItemId,
//   ]);
//   if (res) {
//     const params = {
//       checklistIdParam: Number(route.query.checklistId),
//       showMasterItem: true,
//     };
//     store.dispatch("Assessment/fetchChecklistByCategory", params);
//   }
// };

const isShowAdditionInfo = () => {
  return (
    isExpanded.value &&
    !isExclude.value &&
    (!(
      checklistItemDataRaw.value?.visibleState ===
      assessmentQuestionVisibleState.prefilled
    ) ||
      !isCollapsed.value) &&
    ((checklistItemDataRaw.value.additionalData &&
      checklistItemDataRaw.value.additionalData.length > 0) ||
      (checklistItemDataRaw.value.checklistItemNotes &&
        checklistItemDataRaw.value.checklistItemNotes !== "null"))
  );
};

onMounted(() => initial());

const handleSelectedQuestions = (item: any) => {
  if (isExclude.value || checklistItemDataRaw.value.checklistItemIsNa) return;
  isSelected.value = !isSelected.value;
  emits("update:selected", {
    isSelected: isSelected.value,
  });
};

const getAttachment = (attachmentId: number) => {};

const handleShowBulkAction = () => {
  isShowMoreActionsFileTable.value = !isShowMoreActionsFileTable.value;

  if (selectedFileTableRow.value?.length < 2) {
    isShowMoreActionsFileTable.value = false;
  }
};

const updateSelectedRows = (selectedRows: any[]) => {
  selectedFileTableRow.value = selectedRows;
  if (selectedFileTableRow.value.length < 2) {
    isShowMoreActionsFileTable.value = false;
  }
};
const openDowloadFile = async (attachmentId: number, isAction = false) => {
  try {
    let fileDecrypted: any = {};
    const res = await store.dispatch(
      "Vendor/fetchVendorRequestedAttachment",
      attachmentId,
    );
    if (res.status === successStatusCodes.OK && res.data.data) {
      const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
      const passkeyDecrypt = await decryptText(passkeyQuestion.value, pwdFeIv);
      fileDecrypted = await decryptFileBase64(
        res.data.data,
        passkeyDecrypt ? passkeyDecrypt : passkeyQuestion.value,
      );
    }
    if (!fileDecrypted) {
      showError(
        "app-component-assessments-securing-evidence-modal-decrypt-error-1",
      );
      return;
    }
    if (!isAction || !fileDecrypted.fileType.includes("image")) {
      utilities.downloadBase64File(
        fileDecrypted.fileName,
        fileDecrypted.file,
        fileDecrypted.fileMimeTypeDetected,
      );

      showToastSuccess(
        getComponentUiText(
          "app-component-assessment-modal-assessment-toast-download-1",
        ),
      );
    } else {
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_VENDOR_ASSESSMENT_ATTACHMENT,
        properties: {
          urlAttachment: fileDecrypted.file,
        },
      };

      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
    }
  } catch (error: any) {
    showError(error?.message);
    return {};
  }
};
const showToastSuccess = (message) => {
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const checkPasswordConfirm = async (attachmentId, password) => {
  const res = await store.dispatch(
    "Vendor/fetchVendorRequestedAttachment",
    attachmentId,
  );
  const file = await decryptFileBase64(res.data.data, password);
  return file;
};

const openSecuringModal = (
  attachmentId: number | null,
  type,
  isAction = false,
) => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type,
      attachmentId,
      isVendorRequest: CHECKLIST_TYPE.reviewChecklist,
      checklistItemId: checklistItemDataRaw.value.checklistItemId,
      styleClass: { background: "rgba(0, 0, 0, 0.5)", top: "0px" },
    },
    events: {
      "update:data": (passkey) => {
        passkeyQuestion.value = passkey;
        attachmentId && openDowloadFile(attachmentId, isAction);
      },
      "update:close": () => {
        refreshImage();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const downloadAttachment = async (attachmentId: number, isAction = false) => {
  if (passkeyQuestion.value) openDowloadFile(attachmentId, isAction);
  else {
    const checkProvider = await checkPasswordConfirm(
      attachmentId,
      getPasswordDefaultVendorAttachment(providerId.value),
    );
    if (checkProvider) {
      if (!isAction || !checkProvider.fileType.includes("image")) {
        utilities.downloadBase64File(
          checkProvider.fileName,
          checkProvider.file,
          checkProvider.fileMimeTypeDetected,
        );
      } else {
        const emitData: IModalMessage = {
          component: MODAL_NAME.MODAL_VENDOR_ASSESSMENT_ATTACHMENT,
          properties: {
            urlAttachment: checkProvider.file,
          },
        };
        EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      }
    } else {
      openSecuringModal(
        attachmentId,
        TYPE_MODAL_SECURING_EVIDENCE.DECRYPT,
        isAction,
      );
    }
  }
};
const deleteAttachment = async (attachmentId: number) => {
  try {
    const res = await deleteVendorRequestAssessmentAttachment(
      props.checklistId,
      props.checklistItem.checklistItemId,
      [attachmentId],
    );

    store.dispatch("Vendor/delAttachmentItemChecklistRequestedInput", {
      attachmentIds: [attachmentId],
      checklistItemId: props.checklistItem.checklistItemId,
    });

    if (res.status !== successStatusCodes.OK) {
      showError(
        "app-component-assessments-requested-email-toast-delete-attachment-failed-1",
      );
      return;
    }

    let toastMessage = getComponentUiText(
      "app-component-assessments-requested-email-toast-delete-attachment-successfully-1",
    );

    dataTableFileFormatted.value.length === 0 && (selected.value = undefined);
    refreshImage();
    showToastSuccess(toastMessage);
  } catch (error: any) {
    showErrorAPI(error, Vendor.deleteRequestAssessmentAttachment, error.status);
  }
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  .card-container {
    flex-direction: column;

    .card-content {
      width: 80%;
    }
  }
}

.assessmentQuestion {
  display: flex;
  justify-content: space-between;
  border: 1px solid #eff0f1;
  border-radius: 6px;
  background: #fff;
  width: 100%;
  /* max-width: 1060px; */
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);

  @media (max-width: 1536px) {
    max-width: 100%;
  }
}

.question:hover {
  background: rgba(242, 248, 255, 0.5);
}

.bgGrey {
  background: #fcfcfd !important;
  border: 1px solid #eff0f1 !important;
}

.level2Bg {
  border: 1px solid #eff0f1 !important;
  background: #fff !important;
}

.questionWrapper > * {
  transition: opacity 0.3s ease-in-out;
}

.collapsed {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.open {
  opacity: 1;
  height: auto;
}

.greyed {
  opacity: 0.5 !important;
}

.disabled {
  pointer-events: none;
  background-color: #62a2f5;
  color: #666666;
}

button:hover {
  cursor: pointer;
  color: #387dff;
}

button {
  border: 1.5px solid var(--ui-rule, #eff0f1);
  background: var(--ui-white, #fff);
}

.text-with-icon {
  display: flex;
  align-items: center;
  margin: 0;
}

.info-icon {
  margin-left: 5px;
  vertical-align: middle;
}
</style>
